import Card from "./card.js";
export default class ClassicCard extends Card {
  constructor(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m) {
    super(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m),
      (this.U = "ab-classic-card"),
      (this.V = !0);
  }
  tt() {
    const s = {};
    return (
      (s[Card.it.st] = Card.et.Mt),
      (s[Card.it.rt] = this.id),
      (s[Card.it.ot] = this.viewed),
      (s[Card.it.ct] = this.title),
      (s[Card.it.nt] = this.imageUrl),
      (s[Card.it.dt] = this.description),
      (s[Card.it.ut] = this.updated),
      (s[Card.it.lt] = this.created),
      (s[Card.it.ft] = this.categories),
      (s[Card.it.xt] = this.expiresAt),
      (s[Card.it.URL] = this.url),
      (s[Card.it.bt] = this.linkText),
      (s[Card.it.gt] = this.aspectRatio),
      (s[Card.it.jt] = this.extras),
      (s[Card.it.zt] = this.pinned),
      (s[Card.it.kt] = this.dismissible),
      (s[Card.it.qt] = this.clicked),
      (s[Card.it.vt] = this.test),
      s
    );
  }
}
